/* Product Main – Hover Video Block (pmv) */
(function () {
    function init(root) {
        if (!root || root.dataset.init === "1") return;
        root.dataset.init = "1";

        const video = root.querySelector('video');
        const btn = root.querySelector('.pmv__play');
        const hoverEnabled = String(root.dataset.hover) === 'true';
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!video) return;

        // Autoplay eligibility on all browsers
        video.muted = true;       // default to muted for hover preview
        video.playsInline = true;

        // Track whether the user has explicitly chosen "full" playback with sound
        let userActivePlayback = false;

        function setPlaying(on) {
            root.classList.toggle('pmv--playing', !!on);
            if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        }

        function safePlayMuted() {
            // For hover preview (no user gesture needed)
            video.muted = true;
            video.play().then(() => setPlaying(true)).catch(() => {});
        }

        function playWithSound() {
            // For explicit user-initiated playback
            userActivePlayback = true;
            video.muted = false;
            video.play().then(() => setPlaying(true)).catch(() => {});
        }

        function pause() {
            video.pause();
            setPlaying(false);
        }

        // Hover play/pause on desktop (preview mode only)
        if (hoverEnabled && !prefersReduced) {
            root.addEventListener('pointerenter', () => {
                if (userActivePlayback) return; // don't interfere with user-activated playback
                safePlayMuted();
            });
            root.addEventListener('pointerleave', () => {
                if (userActivePlayback) return; // keep playing like a regular video
                pause();
            });
        }

        // Click/tap: play with sound like a regular video
        function onPrimaryActivate(e) {
            // If it was playing via hover (muted), clicking should just unmute and mark as user-activated
            if (!video.paused && !userActivePlayback) {
                playWithSound();
                return;
            }
            // Toggle play/pause in user-activated mode
            if (video.paused) {
                playWithSound();
            } else {
                pause();
                userActivePlayback = false; // revert to preview mode for future hovers
                video.muted = true;
            }
        }

        // Bind to both the button (if present) and the media itself
        if (btn) {
            btn.addEventListener('click', onPrimaryActivate);
            // Basic keyboard support if your button isn't already a native <button>
            btn.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onPrimaryActivate();
                }
            });
        }
        // Allow clicking directly on the video/cover area
        root.addEventListener('click', (e) => {
            // avoid double-handling when the button was clicked
            if (btn && (e.target === btn || btn.contains(e.target))) return;
            // ignore clicks on links inside the block
            const a = e.target.closest('a'); if (a) return;
            onPrimaryActivate();
        });

        // Pause when out of view
        const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (!e.isIntersecting) {
                    pause();
                    // Do not clear userActivePlayback here; if they come back, clicking resumes with sound
                }
            });
        }, { threshold: 0.15 });
        io.observe(root);
    }

    function boot() {
        document.querySelectorAll('.pmv').forEach(init);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
        boot();
    }

    // Theme editor: re-init on section/block changes
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', (e) => {
        const el = e?.target?.closest?.('.pmv'); if (el) init(el);
    });
})();
